// removed by extract-text-webpack-plugin
module.exports = {"Bluecheese":"#615CFF","Oyster":"#C0C5C9","link":"G74cc71","icon":"G649a2a","label":"Geab829 G3c3c24 Gc3ece6"};